import React, { useState, useEffect } from 'react';

import OpportunityService from '../../views/CRM/Opportunity/services/opportunityService';
import { toast } from 'react-toastify';

import {
  ColdIndicator,
  HotIndicator,
  LabelItem,
  LabelsContainer,
  ProgressBar,
  ProgressBarContainer,
  SelectedIndicator,
  TemperatureContainer,
  TemperatureLabel,
  WarmIndicator
} from './styled';

const OpportunityTemperature = ({
  initialTemperature = null,
  onChange,
  opportunityId
}) => {
  const getTemperatureFromValue = (value) => {
    if (!value) return null;
    if (value <= 3) return 1;
    if (value <= 7) return 5;
    return 10;
  };

  const [selectedTemperature, setSelectedTemperature] = useState(
    getTemperatureFromValue(initialTemperature)
  );
  const [isUpdating, setIsUpdating] = useState(false);

  useEffect(() => {
    if (initialTemperature !== null) {
      setSelectedTemperature(getTemperatureFromValue(initialTemperature));
    }
  }, [initialTemperature]);

  const temperatureOptions = [
    {
      id: 1,
      label: 'Frio',
      position: 'left'
    },
    {
      id: 5,
      label: 'Morno',
      position: 'center'
    },
    {
      id: 10,
      label: 'Quente',
      position: 'right'
    }
  ];

  const handleTemperatureClick = async (temperatureValue) => {
    if (isUpdating || selectedTemperature === temperatureValue) return;

    if (!opportunityId) {
      setSelectedTemperature(temperatureValue);
      if (onChange) onChange(temperatureValue);

      return;
    }

    setIsUpdating(true);

    try {
      await OpportunityService.changeTemperature(
        opportunityId,
        temperatureValue
      );

      setSelectedTemperature(temperatureValue);

      if (onChange) {
        onChange(temperatureValue);
      }

      toast.success('Temperatura da oportunidade atualizada com sucesso!');
    } catch (error) {
      toast.error('Erro ao atualizar a temperatura da oportunidade');
    } finally {
      setIsUpdating(false);
    }
  };

  const getIndicatorComponent = (option) => {
    const isSelected = selectedTemperature === option.id;

    if (option.position === 'left') {
      return (
        <ColdIndicator
          $isSelected={isSelected}
          onClick={() => handleTemperatureClick(option.id)}
          style={{
            transform: isSelected
              ? 'translateY(-50%) scale(1.5)'
              : 'translateY(-50%)',

            pointerEvents: isUpdating ? 'none' : 'auto'
          }}
        >
          {isSelected && <SelectedIndicator />}
        </ColdIndicator>
      );
    } else if (option.position === 'center') {
      return (
        <WarmIndicator
          $isSelected={isSelected}
          onClick={() => handleTemperatureClick(option.id)}
          style={{
            transform: isSelected
              ? 'translateX(-50%) translateY(-50%) scale(1.5)'
              : 'translateX(-50%) translateY(-50%)',
            pointerEvents: isUpdating ? 'none' : 'auto'
          }}
        >
          {isSelected && (
            <SelectedIndicator
              style={{
                left: '50%',
                transform: 'translateX(-50%) translateY(-50%)'
              }}
            />
          )}
        </WarmIndicator>
      );
    } else {
      return (
        <HotIndicator
          $isSelected={isSelected}
          onClick={() => handleTemperatureClick(option.id)}
          style={{
            transform: isSelected
              ? 'translateY(-50%) scale(1.5)'
              : 'translateY(-50%)',

            pointerEvents: isUpdating ? 'none' : 'auto'
          }}
        >
          {isSelected && <SelectedIndicator />}
        </HotIndicator>
      );
    }
  };

  return (
    <TemperatureContainer>
      <TemperatureLabel>Temperatura da oportunidade</TemperatureLabel>
      <ProgressBarContainer>
        <ProgressBar>
          {temperatureOptions.map((option) => getIndicatorComponent(option))}
        </ProgressBar>
      </ProgressBarContainer>
      <LabelsContainer>
        <LabelItem $isSelected={selectedTemperature === 1}>Fria</LabelItem>
        <LabelItem $isSelected={selectedTemperature === 5}>Morno</LabelItem>
        <LabelItem $isSelected={selectedTemperature === 10}>Quente</LabelItem>
      </LabelsContainer>
    </TemperatureContainer>
  );
};

export default OpportunityTemperature;
